import {AbstractGrassListener} from "../framework/AbstractGrassListener";
import {MenuPage} from "../framework/MenuPage";
import {PLANET_CARD_TYPES} from "../constants/PlanetCardTypes";
import {PLAYER_TYPES} from "../constants/PlayerTypes";
import {ClearTileSelectionEvent} from "../events/ClearTileSelectionEvent";

export class NewPlanetListener extends AbstractGrassListener {

  /**
   * @param {GameState} gameState
   * @param {GuildAPI} guildAPI
   * @param {MapManager} mapManager
   */
  constructor(
    gameState,
    guildAPI,
    mapManager
  ) {
    super('NEW_PLANET');
    this.gameState = gameState;
    this.guildAPI = guildAPI;
    this.mapManager = mapManager;
    this.redirectControllerName = 'Fleet';
    this.redirectPageName = 'index';
    this.redirectOptions = {planetCardType: PLANET_CARD_TYPES.ALPHA_BASE_ARRIVED};
    this.redirectCallback = () => {};
  }

  handler(messageData) {
    if (
      this.gameState.keyPlayers[PLAYER_TYPES.PLAYER].player
      && messageData.category === 'player_consensus'
      && messageData.subject === `structs.player.${this.gameState.thisGuild.id}.${this.gameState.keyPlayers[PLAYER_TYPES.PLAYER].id}`
      && messageData.planet_id
    ) {
      this.shouldUnregister = () => true;
      const playerId = this.gameState.keyPlayers[PLAYER_TYPES.PLAYER].id;

      this.gameState.keyPlayers[PLAYER_TYPES.PLAYER].player.planet_id = messageData.planet_id;

      Promise.all([
        this.guildAPI.getPlanet(messageData.planet_id),
        this.guildAPI.getFleetByPlayerId(playerId),
        this.guildAPI.getStructsByPlayerId(playerId)
      ]).then(([planet, fleet, structs]) => {

        // Filter fleet structs to prevent abandoned planetary
        // structs from rendering as destroyed on the new planet.
        const fleetStructs = structs.filter(struct => struct.location_type === 'fleet');

        this.gameState.keyPlayers[PLAYER_TYPES.PLAYER].setPlanet(planet);
        this.gameState.keyPlayers[PLAYER_TYPES.PLAYER].setPlanetShieldHealth(this.gameState.currentBlockHeight);
        this.gameState.keyPlayers[PLAYER_TYPES.PLAYER].setFleet(fleet);
        this.gameState.keyPlayers[PLAYER_TYPES.PLAYER].player.fleet_id = fleet.id;
        this.gameState.keyPlayers[PLAYER_TYPES.PLAYER].setStructs(fleetStructs);

        this.mapManager.configureAlphaBaseMap();
        this.gameState.alphaBaseMap.render();

        // Any tile selected on the previous planet is no longer valid so clear it
        window.dispatchEvent(new ClearTileSelectionEvent());

        MenuPage.router.goto(this.redirectControllerName, this.redirectPageName, this.redirectOptions);

        this.redirectCallback();
      });
    }
  }
}